import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const QuickActionButton = ({ userRole = 'field_worker' }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getQuickActions = () => {
    switch (userRole) {
      case 'field_worker': case'technician':
        return [
          {
            label: 'Neuer Scan',
            icon: 'Scan',
            action: () => navigate('/vin-scanner'),
            primary: true
          },
          {
            label: 'Aufträge',
            icon: 'ClipboardList',
            action: () => navigate('/order-management-dashboard')
          }
        ];
      case 'dispatcher':
        return [
          {
            label: 'Neue Fahrt',
            icon: 'Plus',
            action: () => navigate('/order-management-dashboard'),
            primary: true
          },
          {
            label: 'Scanner',
            icon: 'Scan',
            action: () => navigate('/vin-scanner')
          },
          {
            label: 'Techniker',
            icon: 'Users',
            action: () => navigate('/technician-assignment')
          }
        ];
      case 'admin':
        return [
          {
            label: 'Analytics',
            icon: 'BarChart3',
            action: () => navigate('/revenue-analytics-dashboard'),
            primary: true
          },
          {
            label: 'Autohäuser',
            icon: 'Building2',
            action: () => navigate('/dealership-management')
          }
        ];
      default:
        return [];
    }
  };

  const quickActions = getQuickActions();
  const primaryAction = quickActions?.find(action => action?.primary);
  const secondaryActions = quickActions?.filter(action => !action?.primary);

  if (!primaryAction) {
    return null;
  }

  const handlePrimaryAction = () => {
    if (secondaryActions?.length > 0 && !isExpanded) {
      setIsExpanded(true);
    } else {
      primaryAction?.action();
      setIsExpanded(false);
    }
  };

  const handleSecondaryAction = (action) => {
    action?.action();
    setIsExpanded(false);
  };

  // Hide on desktop and login page
  if (window.innerWidth >= 1024 || location?.pathname === '/login') {
    return null;
  }

  return (
    <>
      {/* Overlay */}
      {isExpanded && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-25 z-1200"
          onClick={() => setIsExpanded(false)}
        />
      )}
      {/* Quick Action Button */}
      <div className="fixed bottom-6 right-6 z-1300 lg:hidden">
        {/* Secondary Actions */}
        {isExpanded && secondaryActions?.length > 0 && (
          <div className="absolute bottom-16 right-0 space-y-3 animate-slide-in">
            {secondaryActions?.map((action, index) => (
              <div
                key={index}
                className="flex items-center justify-end space-x-3"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <span className="bg-popover text-popover-foreground px-3 py-1 rounded-lg text-sm font-medium shadow-modal">
                  {action?.label}
                </span>
                <Button
                  variant="secondary"
                  size="icon"
                  onClick={() => handleSecondaryAction(action)}
                  className="w-12 h-12 rounded-full shadow-modal"
                >
                  <Icon name={action?.icon} size={20} />
                </Button>
              </div>
            ))}
          </div>
        )}

        {/* Primary Action Button */}
        <Button
          variant="default"
          size="icon"
          onClick={handlePrimaryAction}
          className={`w-14 h-14 rounded-full shadow-modal transition-transform duration-200 ${
            isExpanded ? 'rotate-45' : 'hover:scale-105'
          }`}
        >
          <Icon 
            name={isExpanded && secondaryActions?.length > 0 ? "Plus" : primaryAction?.icon} 
            size={24} 
          />
        </Button>
      </div>
    </>
  );
};

export default QuickActionButton;